export const dropdownMenu = {
  profile: "Área Personal",
  mobilePaidAccounts: "Cuentas Pago Móvil",
  movements: "Movimientos",
  contact: "Contactos",
  changePassword: "Cambiar Clave",
  inviteFriend: "Invitar a un amigo",
  deposit: "Depósitos",
  withdrawal: "Retiros",
  transfer: "Transferencias",
  logout: "Cerrar Sesión",
  points: "Puntos",
  level: "Nivel",
  language: "Idioma",
  backToPersonalArea: "Volver a Área Personal",
};
